/**
 * @ui-ng-calendar
 */
import 'ui-ng-delegate';
import 'ui-ng-popover';
import 'utility-ng-time';
import 'utility-ng-interface';
import 'utility-ng-configuration';
import 'utility-ng-kernel';

angular.module('ui-ng-calendar', [
  'ui-ng-delegate',
  'ui-ng-popover',
  'utility-ng-time',
  'utility-ng-configuration',
  'utility-ng-interface',
  'utility-ng-kernel'
]);

require('./config/calendar_configuration.ts');
require('./builders/time/changed_busy_time_builder.ts');
require('./builders/time/time_occurrence_builder.ts');
require('./commands/add_raw_time.ts');
require('./commands/add_raw_times.ts');
require('./commands/add_raw_times_in_preview_mode.ts');
require('./commands/add_built_time.ts');
require('./commands/add_new_time.ts');
require('./commands/add_new_potential_time.ts');
require('./commands/create_default_time.ts');
require('./commands/copy_time_occurrence_to_cell.ts');
require('./commands/load_time.ts');
require('./commands/delete_time.ts');
require('./commands/delete_all_times.ts');
require('./commands/delete_preview_times.ts');
require('./commands/update_time.ts');
require('./commands/copy_time_property.ts');
require('./commands/start_time_datasource_transaction.ts');
require('./commands/end_time_datasource_transaction.ts');
require('./commands/reset_times_store.ts');
require('./commands/external_action.ts');
require('./commands/save_changed_busy_time.ts');
require('./commands/reset_changed_busy_time.ts');
require('./commands/delete_changed_busy_time.ts');
require('./component/calendar_component.ts');
require('./datastore/time/data_types.ts');
require('./datastore/time/time_datasource.ts');
require('./datastore/time/changed_busy_time_datasource.ts');
require('./directives/calendar_time_input/calendar_time_input.ts');
require('./engines/time/time_engine.ts');
require('./engines/time/time_types.ts');
require('./functions/get_css_class.ts');
require('./functions/get_day_enums.ts');
require('./old/functions/calendar_time_fn.es.js');
require('./query_models/blended_times_query_model.ts');
require('./query_models/ordered_time_query_model.ts');
require('./query_models/online_times_query_model.ts');
require('./query_models/unlocked_time_query.ts');
require('./servants/time/time_occurrence_servant.ts');
require('./servants/data_types.ts');
require('./strategies/busy_time_strategy.ts');
require('./old/types/time_actions_enum.es.js');
require('./performance/disable_animate_directive.ts');
require('./performance/isolate_digest_directives.ts');
require('./utility/execute_command_in_serial.es.js');
require('./validation/contracts.ts');
require('./validation/reconcile_overlapping_times_corrector.ts');
require('./validation/remove_time_occurrence_corrector.ts');
require('./validation/time_config_validator.ts');
require('./validation/time_lock_validator.ts');
require('./validation/time_start_validator.ts');
require('./validation/time_end_validator.ts');
require('./validation/time_overlap_validator.ts');
require('./validation/correctors/time_lower_bound_corrector.ts');
require('./validation/correctors/time_upper_bound_corrector.ts');
require('./views/list_calendar_view/list_calendar_component.ts');
require('./views/week_calendar_view/week_calendar_component.ts');
require('./views/calendar_color_key/calendar_color_key_component.ts');
require('./views/calendar_color_key_full/calendar_color_key_full_component.ts');
require('./views/add_empty_time/add_empty_time_component.ts');
require('./servants/week_calendar/week_calendar_servant.ts');
require('./strategies/busy_time_strategy.ts');

export * from './builders/time/changed_busy_time_builder';
export * from './builders/time/time_occurrence_builder';
export * from './config/calendar_configuration';
export * from './commands/add_raw_time';
export * from './commands/add_raw_times';
export * from './commands/add_raw_times_in_preview_mode';
export * from './commands/add_built_time';
export * from './commands/add_new_time';
export * from './commands/add_new_potential_time';
export * from './commands/create_default_time';
export * from './commands/copy_time_occurrence_to_cell';
export * from './commands/load_time';
export * from './commands/delete_time';
export * from './commands/delete_all_times';
export * from './commands/delete_preview_times';
export * from './commands/update_time';
export * from './commands/copy_time_property';
export * from './commands/start_time_datasource_transaction';
export * from './commands/end_time_datasource_transaction';
export * from './commands/reset_times_store';
export * from './commands/external_action';
export * from './component/calendar_component';
export * from './datastore/time/data_types';
export * from './datastore/time/time_datasource';
export * from './datastore/time/changed_busy_time_datasource';
export * from './directives/calendar_time_input/calendar_time_input';
export * from './engines/time/time_engine';
export * from './engines/time/time_types';
export * from './functions/get_css_class';
export * from './functions/get_day_enums';
export * from './query_models/blended_times_query_model';
export * from './query_models/ordered_time_query_model';
export * from './query_models/online_times_query_model';
export * from './query_models/unlocked_time_query';
export * from './servants/time/time_occurrence_servant';
export * from './servants/data_types';
export * from './strategies/busy_time_strategy';
export * from './validation/contracts';
export * from './validation/reconcile_overlapping_times_corrector';
export * from './validation/remove_time_occurrence_corrector';
export * from './validation/time_config_validator';
export * from './validation/time_lock_validator';
export * from './validation/time_start_validator';
export * from './validation/time_end_validator';
export * from './validation/time_overlap_validator';
export * from './validation/correctors/time_lower_bound_corrector';
export * from './validation/correctors/time_upper_bound_corrector';
export * from './views/list_calendar_view/list_calendar_component';
export * from './views/week_calendar_view/week_calendar_component';
export * from './views/calendar_color_key/calendar_color_key_component';
export * from './views/add_empty_time/add_empty_time_component';
export * from './servants/week_calendar/week_calendar_servant';
export * from './external_actions/transaction_types';

export default 'ui-ng-calendar';



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/main.ts